<template>
  <label class="checkbox" :class="{ 'checkbox--disabled': disabled}">
    <input
      type="checkbox"
      :checked="value"
      @change="onChange"
      :disabled="disabled"
    />
    <span class="checkmark">
      <svg
        class="icon"
        viewBox="0 0 10 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.54412 5.00036C2.25122 4.70747 1.77635 4.70747 1.48346 5.00036C1.19056 5.29325 1.19056 5.76813 1.48346 6.06102L2.65018 7.22775C3.0462 7.62376 3.24421 7.82177 3.47254 7.89596C3.67338 7.96122 3.88973 7.96122 4.09057 7.89596C4.3189 7.82177 4.51691 7.62376 4.91292 7.22775L8.90808 3.23259C9.20097 2.9397 9.20097 2.46482 8.90808 2.17193C8.61518 1.87904 8.14031 1.87904 7.84742 2.17193L3.78155 6.2378L2.54412 5.00036Z"
          fill="white"
        />
      </svg>
    </span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "UICheckbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    
  },
  methods: {
    onChange(e) {
      const checked = e.target.checked
      this.$emit("input", checked)   // v-model uchun
      this.$emit("change", checked)  // @change uchun
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  &--disabled{
    cursor: not-allowed
  }
}

.checkbox input {
  display: none;
  
}

.checkmark {
  width: 16px;
  height: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.checkmark .icon {
  width: 10px;
  height: 10px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.checkbox input:checked + .checkmark {
  background: #3f32b5;
  border-color: #3f32b5;
}

.checkbox input:checked + .checkmark .icon {
  opacity: 1;
}
</style>
